import { Select, Space } from "antd";

const PlotSettings = ({ options, yAxisVar, setYAxisVar }) => {
  return (
    <>
      <Space>
        Variable sur l'axe y{" "}
        <Select
          style={{ width: 180 }}
          value={yAxisVar}
          onChange={setYAxisVar}
          options={options}
        />
      </Space>
    </>
  );
};

export default PlotSettings;
